import * as Yup from 'yup'

export const RatingSchema = Yup.object().shape({
  quality_score: Yup.number().integer('Select a whole star rating').min(1, 'Select a rating').max(5, 'Must be max 5').typeError('Select a rating'),
  professional_score: Yup.number().integer('Select a whole star rating').min(1, 'Select a rating').max(5, 'Must be max 5').typeError('Select a rating'),
});
